<!-- Template -->

<template>
    <div @mousemove="resetCounterInterval">
        <idle-dialog :visible="visible" :counter="dialogCounter" @stayLoggedIn="stayLoggedIn" @doLogOut="doLogOut"></idle-dialog>
        <router-view />
    </div>
</template>

<!-- Script -->
<script>
    import IdleDialog from './components/Dialogs/Idle';
    import { AccountService } from '@/services/account-service'; 

    export default {
        components:{
            idleDialog: IdleDialog
        },

        data() {
            return {
                visible:false,
                timeUntilLoggingOut: 540, // in seconds
                counter: null, 
                counterInterval: null,
                timeout: false, 
                dialogTimeUntilLoggingOut: 60,  // in seconds
                dialogCounter: null, 
                dialogTimeout: false
            };
        },

        created(){
            this.startCounter();  
            this.AccountService = new AccountService(this.$api, this.$store, this.$router);
        },

        methods: {
            
            startCounter: function() {
                if(this.$store.getters['session/loggedIn']){
                    this.visible = false;
                    this.counter = this.timeUntilLoggingOut;
                    this.counterInterval = setInterval(this.setCounterInterval, 1000);
                }
            },

            
            setCounterInterval: function() {
                this.counter = this.counter - 1; 
                if (!this.counter) {
                    clearInterval(this.counterInterval); 
                    this.timeout = !this.timeout; 
                    this.startCounterInDialog(); 
                }
            },

            resetCounterInterval: function() {
                if (!this.timeout) {
                    clearInterval(this.counterInterval);
                    this.startCounter();
                }
            },

           
            startCounterInDialog: function() {
                this.visible = true; 
                this.dialogCounter = this.dialogTimeUntilLoggingOut; 
                this.dialogInterval = setInterval(this.setDialogInterval, 1000);
            },

            setDialogInterval: function() {
                this.dialogCounter = this.dialogCounter - 1;
                if (!this.dialogCounter) {
                    clearInterval(this.dialogInterval); 
                    this.dialogTimeout = !this.dialogTimeout; 
                    this.countdownExpired(); 
                }
            },

            countdownExpired: function() {
                this.visible = false;
                this.$store.dispatch('session/reset'); 
                this.$router.push({ name: 'Login' });   
            },

            stayLoggedIn: function(){
                this.visible = false;
                this.timeout = !this.timeout; 
                clearInterval(this.counterInterval);
                this.dialogTimeout = !this.dialogTimeout; 
                clearInterval(this.dialogInterval); 
                this.startCounter();
            },

            doLogOut: function(){
                this.visible = false;
                this.resetCounterInterval();
                this.AccountService.logout(); 
            }
        } 
    };
</script>

<!-- Style -->
<style lang="scss" src="@/styles/main.scss" />